import React from "react";
import { Divider, Typography } from "@material-ui/core";
import useStyles from "./styles";

const Header = ({ title }) => {
  const classes = useStyles();
  return (
    <>
      <Typography variant="body1" gutterBottom>
        {title}
      </Typography>
      <Divider className={classes.subTitleDivider} />
    </>
  );
};

export default Header;
